import { ErrorToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const createCustomer = async (body) => {
  const regRes = await AxiosPostMethod("customer/registration", body, true);
  if (regRes.status === 200) {
    return regRes.data.data;
  } else {
    if (regRes?.status === 409) ErrorToast(regRes.data.data.error);
    else if (regRes?.status === 401) HandleLogout();
    else ErrorToast("Error on Customer Registration. Please do verify data");
    return null;
  }
};

export default createCustomer;
